import {
  CustomSectionNode,
  CustomSectionType,
  CustomSectionNodeType,
  GroupByOption,
  GenerateAsOption,
  ParticipantGroupOption,
  CustomSectionContentState,
} from 'api/custom-section/types';

export const defaultSections: CustomSectionNode[] = [
  {
    type: CustomSectionNodeType.RlCustomSection,
    attrs: {
      templateSectionId: 'new_section_1',
      contentState: CustomSectionContentState.Prompt,
      sectionType: CustomSectionType.MeetingDetails,
      title: 'Meeting Details',
      config: {
        fields: ['meetingName', 'participants'],
      },
    },
    content: [
      {
        type: 'paragraph',
        attrs: {
          textAlign: null,
        },
      },
    ],
  },
  {
    type: CustomSectionNodeType.RlCustomSection,
    attrs: {
      templateSectionId: 'new_section_2',
      contentState: CustomSectionContentState.Prompt,
      sectionType: CustomSectionType.AccountDetails,
      title: 'Account Information',
      config: {
        fields: ['companyName', 'accountOwner'],
      },
    },
    content: [
      {
        type: 'paragraph',
        attrs: {
          textAlign: null,
        },
      },
    ],
  },
  {
    type: CustomSectionNodeType.RlCustomSection,
    attrs: {
      templateSectionId: 'new_section_3',
      contentState: CustomSectionContentState.Prompt,
      sectionType: CustomSectionType.Question,
      title: 'Summary',
      config: {
        aiContext: 'Summarise the meeting',
        groupBy: GroupByOption.Topics,
        generateAs: GenerateAsOption.Paragraph,
        participants: ParticipantGroupOption.All,
      },
    },
    content: [
      {
        type: 'RL_PLACEHOLDER_CONFIG',
        attrs: {
          icon: 'faAlignLeft',
          iconPosition: 'left',
        },
        content: [{ type: 'text', text: 'Topic 1' }],
      },
      {
        type: 'RL_PLACEHOLDER_CONFIG',
        attrs: {
          icon: '',
          iconPosition: 'left',
          disabled: true,
        },
        content: [
          {
            type: 'text',
            text: '...',
          },
        ],
      },
      {
        type: 'RL_PLACEHOLDER_CONFIG',
        attrs: {
          icon: 'faAlignLeft',
          iconPosition: 'left',
        },
        content: [{ type: 'text', text: 'Topic 2' }],
      },
    ],
  },
  {
    type: CustomSectionNodeType.RlCustomSection,
    attrs: {
      templateSectionId: 'new_section_4',
      contentState: CustomSectionContentState.Prompt,
      sectionType: CustomSectionType.Action,
      title: 'Action items',
      config: {
        aiContext: '',
        groupBy: GroupByOption.Topics,
        generateAs: GenerateAsOption.Checklist,
        participants: ParticipantGroupOption.All,
      },
    },
    content: [
      {
        type: 'RL_PLACEHOLDER_CONFIG',
        attrs: {
          icon: 'faSquareCheck',
          iconPosition: 'left',
        },
        content: [
          {
            type: 'text',
            text: 'Action 1',
          },
        ],
      },
      {
        type: 'RL_PLACEHOLDER_CONFIG',
        attrs: {
          icon: '',
          iconPosition: 'left',
          disabled: true,
        },
        content: [{ type: 'text', text: '...' }],
      },
      {
        type: 'RL_PLACEHOLDER_CONFIG',
        attrs: {
          icon: 'faSquareCheck',
          iconPosition: 'left',
        },
        content: [
          {
            type: 'text',
            text: 'Action N',
          },
        ],
      },
    ],
  },
];

export const defaultContent = {
  type: 'doc',
  content: [
    defaultSections[0],
    defaultSections[1],
    defaultSections[2],
    defaultSections[3],
  ],
};

export const DEFAULT_SECTION_IDS = [
  'new_section_1',
  'new_section_2',
  'new_section_3',
  'new_section_4',
];

export const defaultChoices = [
  {
    label: 'Hubspot',
    position: 1,
    value: 1,
  },
  {
    label: 'Salesforce',
    position: 2,
    value: 2,
  },
];
